module.exports = __webpack_public_path__ + "static/media/IC213 CLUSTER.480ae8cb.jpg";